import { withBox } from './withBox'
import { withFlex as withFlexRaw } from './withFlex'
import { withText as withTextRaw } from './withText'
import { withAbsolute as withAbsoluteRaw } from './withAbsolute'
import { ComponentProps } from 'react'

function withFlex<C extends AnyComponent>(Comp: C) {
  return withFlexRaw(withBox(Comp))
}

function withText<C extends AnyComponent>(Comp: C) {
  return withTextRaw(withBox(Comp))
}

function withAbsolute<C extends AnyComponent>(Comp: C) {
  return withAbsoluteRaw(withBox(Comp))
}

export const Box = withBox('div')

export const Absolute = withAbsolute('div')

export const Flex = Object.assign(withFlex('div'), {
  Form: withFlex('form'),
})

export type FlexDivProps = ComponentProps<typeof Flex>

export const Text = Object.assign(withText('p'), {
  P: withText('p'),
  Span: withText('span'),
  Label: withText('label'),
  H1: withText('h1'),
  H2: withText('h2'),
  H3: withText('h3'),
  H4: withText('h4'),
  H5: withText('h5'),
  H6: withText('h6'),
  Li: withText('li'),
})
